import { ConfigEntryFieldType, ConfigEntryType, ConfigFieldEntryType } from 'config/config';

export const SUGGESTION_CONTACT_FORM_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'groupName',
    entryDescription: 'Department',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      label: 'Department',
      placeHolder: 'Select department',
      configRefName: 'DEPARTMENTS',
      isRequired: true,
    },
  },
  {
    entryCode: 'region',
    entryDescription: 'Region',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      label: 'Region',
      placeHolder: 'Select Region',
      configRefName: 'REGIONS',
      isRequired: true,
    },
  },
  {
    entryCode: 'taskOwner',
    entryDescription: 'Contact',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    targetMapperJavaScriptFunction: 'UserListComponent',
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      label: 'Contact',
      placeHolder: 'Select Contact',
      isRequired: true,
    },
  },
];
